<!-- <ng-container  *ngIf="!hideLayout" > -->
<nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm py-1 fixed-top" >
  <div class="container-fluid  ">

<div class="d-flex align-items-center">
  <img src="/awaslogo.png" alt="Awas Logo" class="headlogo me-2" >

  <ng-container *ngIf="!districtSelected">
    <!-- <h2 class="check fw-bold mb-0">Awas Bandhu</h2> -->
    <h2 class="check fw-bold mb-0">Awas Bandhu</h2>
  </ng-container>
  
</div>


<div class="col-md-6 text-end check"  *ngIf="showUserName && common.user">
  <h3>{{ common["user"]["da_name"]  }}</h3>
</div>
 <ng-container *ngIf="districtSelected">
      <img [src]="districtLogo" alt="District Logo" class="headlogoagra me-2" style="width: 60px; height: 61px;">
      <h2 class="districtcheck  mb-0">{{ districtName }} Development Authority</h2>
 </ng-container>
 
  <button *ngIf="showMenuButton" class="btn mobile-toggle d-lg-none ms-auto" type="button" (click)="toggleSidebar()">
      <i class="fa" [ngClass]="isSidebarOpen ? 'fa-times' : 'fa-bars'"></i>
    </button>

   

<div class="profile-container ms-auto d-flex mr-4">
    <select
  class="form-select form-select-sm"
  [value]="currentLang"
  (change)="switchLang($event)"
>
  <option value="en">en</option>
  <option value="hi">hi</option>
</select>

</div>
<div class="d-flex">
 <div class="profile-container ms-auto d-none d-md-flex align-items-center" *ngIf="showProfile">
</div>
  <!-- <div>
    <img src="/bell.png" alt="Notifications" class="me-3" style="width: 22px; cursor: pointer;">
  </div> -->

  <div class="dropdown" *ngIf="!isSessionPassword && showProfile">
    <div class="d-flex align-items-center dropdown-toggle" 
         id="profileDropdown" 
         data-bs-toggle="dropdown"
         aria-expanded="false" 
         style="cursor: pointer;">
      <!-- <img src="/user.jpg" alt="Profile" class="profile-img me-2"> -->
      <div *ngIf="common['user']" style="cursor: pointer;">
        <div class="profile-name ms-4" >{{ common["user"]["username"]  }}</div>
        <div class="ms-4" >
          <!-- <i langText [langTextEn]="'Designation'" [langTextHi]="'पदनाम'"></i> -->
          {{common["user"]["designation"]}}
        </div>
      </div>
    </div>

    <ul class="dropdown-menu dropdown-menu-end shadow" aria-labelledby="profileDropdown" *ngIf="common['user']">
      <li class="dropdown-header d-flex align-items-center">
        <!-- <img src="/user.jpg" alt="Profile" class="profile-img me-2"> -->
        <div>
          <div class="fw-bold">{{common["user"]["username"]}}</div>
          <!-- <small class="text-muted" langText [langTextEn]="'Designation'" [langTextHi]="'पदनाम'"></small> -->
           {{common["user"]["designation"]}}
        </div>
      </li>
      <li><hr class="dropdown-divider"></li>

      <li>
        <a class="dropdown-item" routerLink="/dashboards/profile">
          <img src="/pro.png">
          <span langText [langTextEn]="'Profile'" [langTextHi]="'प्रोफ़ाइल'"></span>
        </a>
      </li>
      <li>
        <a class="dropdown-item" routerLink="/dashboards/password">
          <img src="/pro.png">
          <span langText [langTextEn]="'Password'" [langTextHi]="'पासवर्ड'"></span>
        </a>
      </li>

      <!-- <li>
        <a class="dropdown-item" href="#">
          <img src="/noti.png">
          <span langText [langTextEn]="'Notification'" [langTextHi]="'सूचनाएं'"></span>
        </a>
      </li> -->

      <li>
        <a class="dropdown-item text-danger" href="#" (click)="logout()">
          <img src="/logout.png">
          <span langText [langTextEn]="'Logout'" [langTextHi]="'लॉगआउट'"></span>
        </a>
      </li>
    </ul>
  </div>
</div>


  </div>
</nav>
<!-- </ng-container> -->
<router-outlet></router-outlet>
